import { MonitorMainPanel } from './MonitorMainPanel'
import { MonitorPreviewPanel } from './MonitorPreviewPanel'
import { MonitorStatus } from './MonitorStatus'

export function MonitorView(props) {
  return (
    <div className="space-y-5" data-testid="monitor-command-center">
      <MonitorStatus {...props} />

      <div className="grid min-w-0 grid-cols-1 gap-5 xl:grid-cols-[minmax(0,7fr)_minmax(360px,5fr)] xl:items-start">
        <MonitorMainPanel {...props} />
        <MonitorPreviewPanel {...props} />
      </div>
    </div>
  )
}
